import { createSelector } from 'reselect';
import _ from 'lodash';

export const overlaysSelector = state => state.overlay;

export const currentOverlaysSelector = createSelector(
  overlaysSelector,
  overlays => _.get(overlays, 'overlays', {})
);



/** WEBPACK FOOTER **
 ** ./client/redux/modules/overlay/overlaySelectors.js
 **/